/**
 * chatelles-notify-popup.js — Chatelles
 *
 * Le bouton d'envoi de la fenêtre « M'avertir » (app Back in Stock, GrootApps)
 * est imposé en bleu par l'app via un style inline `!important` ré-appliqué en
 * continu — impossible à surcharger proprement (une animation ne bat pas
 * `!important` dans la cascade CSS, et l'app strip tout style inline ajouté).
 *
 * Solution fiable : on garde le vrai bouton de l'app dans le DOM (invisible,
 * pour conserver toute sa logique d'envoi) et on affiche par-dessus notre
 * propre bouton aux couleurs Chatelles, qui relaie simplement le clic.
 *
 * Le reste du popup est stylé via chatelles-notify-popup.css.
 */
(function () {
  'use strict';

  var MODAL = 'notifyMeModal';
  var REAL = 'notify-submit-btn';
  var obs = null;

  function syncLabel(proxy, real) {
    var t = (real.textContent || '').trim();
    if (t && proxy.textContent !== t) proxy.textContent = t;
  }

  function setupProxy() {
    var real = document.getElementById(REAL);
    if (!real) return;

    // Déjà en place → on se contente de resynchroniser le libellé (langue).
    var parent = real.parentNode;
    if (parent && parent.classList.contains('ch-submit-wrap')) {
      var existing = parent.querySelector('.ch-notify-submit');
      if (existing) { syncLabel(existing, real); return; }
    }

    // Nettoyer d'éventuels wrappers orphelins (bouton remplacé à la réouverture).
    var modal = document.getElementById(MODAL);
    if (modal) {
      modal.querySelectorAll('.ch-submit-wrap').forEach(function (w) {
        if (!w.contains(real)) w.remove();
      });
    }

    var wrap = document.createElement('div');
    wrap.className = 'ch-submit-wrap';
    parent.insertBefore(wrap, real);
    wrap.appendChild(real); // le vrai bouton (masqué en CSS) reste fonctionnel

    var proxy = document.createElement('button');
    proxy.type = 'button';
    proxy.className = 'ch-notify-submit';
    syncLabel(proxy, real);
    proxy.addEventListener('click', function () { real.click(); });
    wrap.appendChild(proxy);

    ensureObserver();
  }

  // Réouverture / reconstruction du formulaire par l'app → on ré-installe.
  function ensureObserver() {
    var modal = document.getElementById(MODAL);
    if (!modal || obs) return;
    obs = new MutationObserver(function () { setupProxy(); });
    obs.observe(modal, { subtree: true, childList: true });
  }

  // Le popup se rend de façon asynchrone à l'ouverture → on tente plusieurs fois.
  function setupSoon() {
    [0, 120, 300, 600, 1000, 1500].forEach(function (d) { setTimeout(setupProxy, d); });
  }

  // Ouvertures : bouton natif « Prévenez-moi » ou clic sur une taille épuisée.
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    if (e.target.closest('#notifyMeButton') || e.target.closest('variant-picker')) setupSoon();
  }, false);

  if (document.readyState !== 'loading') setupProxy();
  else document.addEventListener('DOMContentLoaded', setupProxy);

})();
